import { render, staticRenderFns } from "./PurchaseOrderDetailSummary.vue?vue&type=template&id=4c55bde4&scoped=true"
import script from "./PurchaseOrderDetailSummary.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetailSummary.vue?vue&type=style&index=0&id=4c55bde4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55bde4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c55bde4')) {
      api.createRecord('4c55bde4', component.options)
    } else {
      api.reload('4c55bde4', component.options)
    }
    module.hot.accept("./PurchaseOrderDetailSummary.vue?vue&type=template&id=4c55bde4&scoped=true", function () {
      api.rerender('4c55bde4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderDetailSummary.vue"
export default component.exports